<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('cryptogramGenerator.create.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('cryptogramGenerator.create.title') }}
        </h3>
      </d-col>
    </d-row>
    <cryptogram-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import CryptogramPage from '../components/CryptogramPage.vue';
import { _LOAD_MODEL_, MODEL } from '../components/CryptogramModel';

export default {
  name: 'puzzle-create',
  components: {
    CryptogramPage,
  },
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      if (puzzle) {
        Events.$emit(_LOAD_MODEL_, puzzle);
        return puzzle;
      }
      return cloneDeep(MODEL);
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(['setToggle', 'getPuzzle']),
  },
  mounted() {
    if (this.$route.params.puzzleId) {
      this.getPuzzle(this.$route.params.puzzleId);
    }
  },
};
</script>
